import { FC } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import styles from './strokedButton.module.scss';

export type StrokedButtonProps = {
    label: string;
    href: string;
};

export const StrokedButton: FC<StrokedButtonProps> = ({ label, href }) => {
    return (
        <a href={href} className={styles.button}>
            <div className={styles.buttonInner}>
                <span className={styles.label}>
                    {label.split(' ').map((word, idx) => (
                        <div key={idx}>{word}</div>
                    ))}
                </span>
                <ArrowRightOutlined className={styles.icon} />
            </div>
        </a>
    );
};
